
export default function Terminal(props) {

    const logs = props.logs.map((entry) => { return <>[{new Date(entry.created).toLocaleDateString("en-US")} {new Date(entry.created).toLocaleTimeString("en-US")}] {entry.type}: {entry.message}<br/></>})

    return (
        <div style={{
            backgroundColor: '#000000',
            color: '#ffffff',
            fontFamily: 'monospace',
            padding: '8px',
            height: '350px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column-reverse',
        }}>
            {logs}
        </div>
    );
}